import React from 'react';
import { connect } from 'react-redux';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getDeviceCompareInfoByType } from "../../../../../../store/blocks/devices/parametersSelectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _DeviceParametersHeader = function _DeviceParametersHeader(_ref) {
  var data = _ref.data;
  if (data.length <= 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx('header'),
    "data-t-id": "components-DeviceParametersHeader"
  }, data.map(function (_ref2) {
    var previewUrl = _ref2.previewUrl,
      price = _ref2.price,
      title = _ref2.title;
    return /*#__PURE__*/React.createElement("div", {
      className: cx('compare-device'),
      key: title
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('compare-device__image-container')
    }, /*#__PURE__*/React.createElement("img", {
      alt: "",
      src: previewUrl
    })), /*#__PURE__*/React.createElement("div", {
      className: cx('compare-device__content')
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('compare-device__title')
    }, /*#__PURE__*/React.createElement(Text, {
      size: "size5-r-l",
      tagtype: "h2"
    }, title)), !!(price !== null && price !== void 0 && price.value) && /*#__PURE__*/React.createElement("div", {
      className: cx('compare-device__price')
    }, /*#__PURE__*/React.createElement(Text, {
      size: "size5-m"
    }, "".concat(price.value, " ").concat(price.unit)))));
  }));
};
_DeviceParametersHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.arrayOf(PropTypes.shape({
    previewUrl: PropTypes.string,
    price: PropTypes.shape({
      unit: PropTypes.string,
      value: PropTypes.number
    }),
    title: PropTypes.string
  }))
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    data: getDeviceCompareInfoByType(state)
  };
};
export var DeviceParametersHeader = connect(mapStateToProps)(_DeviceParametersHeader);